var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: "商品导入",
        "before-close": _vm.close,
        width: "30%",
        "custom-class": "upload-form",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "pb16 pl16 pr16" },
        [
          _c(
            "el-row",
            { staticClass: "mt16 mb16", attrs: { type: "flex" } },
            [
              _c("el-col", { attrs: { span: 3 } }, [
                _c("div", { staticStyle: { "margin-top": "8px" } }, [
                  _vm._v("导入模版："),
                ]),
              ]),
              _c(
                "el-col",
                { attrs: { span: 21 } },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "uploadRef",
                      attrs: {
                        action: "",
                        "file-list": _vm.fileList,
                        "http-request": _vm.onUploadFile,
                        "on-change": _vm.onFileChange,
                        accept: ".xlsx, .xls",
                        "auto-upload": false,
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "trigger",
                            size: "small",
                            type: "primary",
                          },
                          slot: "trigger",
                        },
                        [_vm._v("上传文件")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { size: "small", type: "success" },
                          on: { click: _vm.downloadTemplate },
                        },
                        [_vm._v("下载模版")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "mb20", attrs: { type: "flex", justify: "end" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !this.uploadFile },
                  on: { click: _vm.onTriggerUpload },
                },
                [_vm._v("确定")]
              ),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }